<template>
  <div id="messageAdd" ref="messageRef">
    <v-container class="pa-0">
      <v-layout>
        <v-flex class="xs12 sm12 mb-5">
          <v-btn fab absolute left @click="backToListing" class="ml-3 pf-btn-fab">
            <v-icon>arrow_back</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>  
    <v-form ref="formAdd">
      <v-container class="-border">
        <v-layout wrap>
          <v-flex xs12 class="button-container pr-3 text-xs-right">
            <div class="d-inline-flex" v-if="selectedData">
              <v-btn class="pf-btn pf-btn-cancel" @click="backToListing">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="save">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Send</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
        <v-layout v-if="messageRecipients.length" class="d-block mr-4 ml-4">
          <p><label>To</label></p>
          <template v-for="(to, i) in messageRecipients">
            <span :key="i">
              <v-chip
                close
                @input="removeToItem(to)"
              >
                <span>{{ to.name }}</span>&nbsp;
                <span>({{ to.role }})</span>
              </v-chip>
            </span>
          </template>
        </v-layout>
        <v-layout>
          <v-flex class="xs12 sm6 md7">
              <v-autocomplete
                v-model="messageTo" 
                @change="selectedRecipient" 
                @keyup.enter="searchFamilies" 
                :items="recipientList" 
                item-text="name"
                label="Search recipients"
                :rules="[rules.toRule]"
                hide-no-data
                small-chips
                return-object
                multiple
                deletable-chips
                placeholder="Search by Name / Nickname / PPN / Agency"
                hint="Search message groups, admins, agencies or parents. minimum 3 characters required"
                persistent-hint
                id="recipientSearch"
                :search-input.sync="searchInput"
                class="pr-4 pl-4">
                <template v-slot:item="data">
                  <template>
                    <v-list-tile-content>
                      <v-list-tile-title v-html="`${data.item.name} <small>- (${data.item.role})</small>`"></v-list-tile-title>
                      <!-- <v-list-tile-sub-title v-html="data.item.group"></v-list-tile-sub-title> -->
                    </v-list-tile-content>
                  </template>
                </template>
                <v-icon slot="append" @click="searchFamilies"> search </v-icon>
              </v-autocomplete>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex class="xs12 sm6 md7">
            <v-text-field 
              label="Subject" 
              v-model="conversation.subject" 
              class="required pr-4 pl-4" 
              @input="changedData" 
              :rules="[rules.subjectRule]">
            </v-text-field>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex class="xs12 sm6 md7">
          <v-combobox class="pr-4 pl-4" :rules="[rules.multipleEmail]" @change="changedData" v-model="conversation.cc" label="CC" hint="emails - hit enter to add new" multiple deletable-chips small-chips></v-combobox>
          </v-flex>
        </v-layout>     
        <v-layout>
          <v-flex>
            <div id="pageEditor" >
              <v-container grid-list-xl fluid class="pa-0 pt-5">
                <v-layout row wrap>
                  <v-flex sm12>
                    <editor :options="editorOption" :content="content" :init="{ height: 300, menubar: false}" :api-key="apikey" v-model="message.content" @input="changedData" :rules="[rules.contentRule]" />
                    <!-- <quill-editor
                      :class="{'height-300': $vuetify.breakpoint.smAndUp}"
                      :content="content"
                      :options="editorOption"
                      @input="changedData"
                      v-model="message.content"
                      :rules="[rules.contentRule]"
                    >
                    </quill-editor> -->
                  </v-flex>
                </v-layout>
              </v-container>
            </div>
          </v-flex>
        </v-layout>
        <v-layout class="editor-button-container">
          <v-flex xs12 class="button-container pr-3 text-xs-right">
            <div class="d-inline-flex" v-if="selectedData">
              <v-btn class="pf-btn pf-btn-cancel" @click="backToListing">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="save">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Send</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
/* global session router store config */
/* import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor'; */
import Editor from '@tinymce/tinymce-vue';

import swal from 'sweetalert2';
import { getCollection, create, getOne, conversationListPopulate } from '../../helpers/helpers';
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default {
  name: 'adminMessageAdd',
  components: {
    Editor
  },
  data: () => ({
    entity: 'Message',
    searchInput: '',
    conversationEntity: 'Conversation',
    editor: null,
    config: config,
    apikey: config.tinymceEditorKey,
    content: '',
    selectedData: false,
    Recipient: 'Mark / Letty',
    editorOption: {
      placeholder: 'Add content here..',
    },
    query: {
      family: ''
    },
    messageTo: [],
    recipientList: [],
    messageRecipients: [],
    message: {
      content: '',
      conversation: '',
      sender: ''
    },
    conversation: {
      human: [],
      groups: [],
      subject: '',
      cc: []
    },
    conversationIndex: '',
    rules: {
      subjectRule: (v) => !!v || 'Please enter subject',
      toRule: (v) => !!v || 'Please select recipient',
      contentRule: (v) => !!v || 'Please enter reply',
      multipleEmail: (v) => v === undefined || v.length === 0 || /^([\w+-.%]+@[\w-.]+\.[A-Za-z]{2,4},?)+$/.test(v) || 'Please enter valid email address'
    },    
  }),
  computed: {
    ...mapGetters(['Agency', 'Message', 'Conversation']),
    AgencyList: {
      set (value) {
        store.commit('setAgencyList', value);
      },
      get () {
        return store.state.AgencyList;
      }
    },
    Conversation: {
      get () {
        return store.state.Conversation;
      },
      set (value) {
        store.commit('setConversation', value);
      }
    },
    MessageGroup: {
      get () {
        return store.state.MessageGroup;
      },
      set (value) {
        store.commit('setMessageGroup', value);
      }
    }
  },  
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  created () {
    this.getToMessageName();
    this.initializeAgencyList();
    this.initializeMessageGroups();
  },
  mounted () {
    window.getApp.$emit('pageSubHeader', 'Add');
    this.$refs.messageRef.scrollIntoView({ behavior: 'smooth' });
  },
  methods: {
    async updateConversationList () {
      let sort = { 'updatedAt': -1 };
      let sessionUser = session.getSession();
      let where = {};
      where = {
        $and: [
          {
            $or: [
              {
                human: sessionUser.user.human.id
              }
            ]
          },
          {
            $or: [
              {
                archive: { $exists: false }
              },
              {
                archive: {
                  $ne: sessionUser.user.human.id
                }
              }
            ]
          },
          {
            $or: [
              {
                removed: { $exists: false }
              },
              {
                removed: {
                  $ne: sessionUser.user.human.id
                }
              }
            ]
          }
        ]
      };
      if (sessionUser.user.human.group && sessionUser.user.human.group.length) {
        where.$and[0].$or.push({
          groups: {
            $in: sessionUser.user.human.group && sessionUser.user.human.group.length ? sessionUser.user.human.group.map(group => group.group) : []
          }
        });
      }
      let { error, data } = await getCollection(this.conversationEntity, true, 0, await conversationListPopulate(sessionUser.user.human.id), where, null, null, sort);
      if (error) {
        console.log(error);
      } else {
        if (data.length > 0) {
          this.Conversation = data;
        }
      }
    },
    removeToItem (item) {
      const index = this.messageRecipients.indexOf(item);
      if (index >= 0) this.messageRecipients.splice(index, 1);
    },
    selectedRecipient () {
      this.changedData();
      this.messageTo.forEach(to => {
        if (this.messageRecipients.findIndex(x => x.id === to.id) === -1) {
          this.messageRecipients.push(to);
        }
      });
      this.messageTo = [];
    },
    // @vuese
    // Used to search for recipients on entering family name, nickname, PPN or the agency name
    // @arg The keyup event object
    async initializeAgencyList () {
      if (!this.AgencyList.length) {
        let where = { _id: { $ne: this.Agency.id }};
        let attributes = 'name,createdAt,_id,is_admin,avatar';
        let populate = [{ path: 'human', select: '_id name user' }];
        let { error, data } = await getCollection('Agency', true, 0, populate, where, attributes);
        if (error) {
          console.log(error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Failed to load client list'
          };
        } else {
          if (data.length > 0) {
            store.commit('setAgencyList', data);
          }
        }
      }
    },
    async initializeMessageGroups () {
      if (!this.MessageGroup.length) {
        let { error, data } = await getCollection('MessageGroup', true, 0);
        if (error) {
          console.log(error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Failed to load message groups'
          };
        } else {
          if (data.length > 0) {
            this.MessageGroup = data;
          }
        }
      }
    },
    async searchFamilies () {
      this.recipientList = !this.messageTo.length ? [] : this.recipientList;
      this.query.family = this.searchInput;
      let profile_number = this.query.family;
      let profile_year = this.query.family;
      if (this.query.family && this.query.family.length > 2) {
        let where = { };
        if (this.query.family && this.query.family.length) {
          if (!where.$or) {
            where.$or = [{
              $expr: {
                $eq: [this.query.family, {
                  $concat: [{
                    '$toString': '$profile_year'
                  }, '_', {
                    '$toString': '$profile_number'
                  }]
                }]
              }
            }, {
              'nickname': { $regex: `.*` + this.query.family + `.*`, $options: 'i' }
            }, {
              'name': { $regex: `.*` + this.query.family + `.*`, $options: 'i' }
            }];
          } else {
            where.$or.push({
              $expr: {
                $eq: [this.query.family, {
                  $concat: [{
                    '$toString': '$profile_year'
                  }, '_', {
                    '$toString': '$profile_number'
                  }]
                }]
              }
            });
            where.$or.push({
              'nickname': { $regex: `.*` + this.query.family + `.*`, $options: 'i' }
            });
            where.$or.push({
              'name': { $regex: `.*` + this.query.family + `.*`, $options: 'i' }
            });
          }
        }
        if (this.query.family && !isNaN(this.query.family)) {
          where.$or.push({
            'profile_number': this.query.family
          });
        }
        if (this.query.status) {
          where.profile_status = this.query.status;
        }
        let populate = [{ 'path': 'human', 'select': 'id' }, 'contactInfo.country', 'contactInfo.state'];
        let attributes = 'name,nickname,profile_year,profile_number';
        let { error, data } = await getCollection('Account', true, 0, populate, where, attributes);
        if (error) {
          console.log(error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Failed to load client list'
          };
        } else {
          if (data.length > 0) {
            this.recipientList = this.formatRecipients(data);
          }
          this.agencyFilter();
          this.groupFilter();
        }
      }
    },
    formatRecipients (data) {
      let recipients = [];
      if (data.length) {
        data.forEach(row => {
          if (typeof row.human[0].id !== 'undefined') {
            let entry = {
              type: 'human',
              id: row.human[0].id,
              name: row.name ? row.name : (row.human[0].first_name + ' ' + row.human[0].last_name),
              role: 'parent'
            };
            if (row.nickname.toLowerCase().includes(this.searchInput.toLowerCase())) {
              entry.name = row.nickname;
            } else {
              entry.name = row.ppn === this.searchInput ? `${row.ppn} / ${row.name}` : entry.name;
              
            }
            recipients.push(entry);
          }
        });
      }
      return recipients;
    },
    async agencyFilter () {
      if (this.query.family && this.query.family.length > 2) {
        let filteredList = this.AgencyList.filter((element) => {
          if (element.name.toLowerCase().includes(this.query.family.toLowerCase())) {
            return element;
          }
          return false;
        });

        if (filteredList.length) {
          filteredList.forEach(item => {
            let obj = {
              type: 'human',
              id: item.human[0].id,
              name: item.name ? item.name : (item.human[0].first_name + ' ' + item.human[0].last_name),
              role: item.is_admin ? 'admin' : 'agency'
            };
            this.recipientList.push(obj);
          });
        }
      }
    },
    async groupFilter () {
      if (this.query.family && this.query.family.length > 2 && this.MessageGroup.length) {
        let filteredList = this.MessageGroup.filter((element) => {
          if (element.name.toLowerCase().includes(this.query.family.toLowerCase())) {
            return element;
          }
          return false;
        });

        if (filteredList.length) {
          filteredList.forEach(item => {
            let obj = {
              type: 'group',
              id: item.id,
              name: item.name,
              role: 'group'
            };
            this.recipientList.push(obj);
          });
        }
      }
    },
    changedData () {
      this.selectedData = true;
    },
    hideButtons () {
      this.selectedData = false;
    },
    getToMessageName () {
      if (this.$route.params.preUrl && ['/admin/families', '/admin/agencies'].indexOf(this.$route.params.preUrl) > -1) {
        let item = this.$route.params.item;
        if (item) {
          let obj = {
            type: 'human',
            id: item.human,
            name: item.name,
            role: item.role
          };
          this.recipientList.push(obj);
          this.messageRecipients.push(obj);
          this.changedData();
        }
      }
    },
    async save () {
      if (this.$refs.formAdd.validate()) {
        if (!this.message.content.replace(/(<([^>]+)>)/ig, '').replace(/\s/g, '').length) {
          swal.fire({
            type: 'warning',
            title: 'Content is required.',
            text: 'Please add message content before saving!',
            showConfirmButton: true,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'OK'
          });
          return;
        }
        this.selectedData = false;
        if (this.conversation.cc && !this.conversation.cc.length) {
          delete this.conversation.cc;
        }
        this.conversation.human = Array.from(this.messageRecipients.filter(x => x.role !== 'group'), x => x.id);
        this.conversation.human.push(this.Agency.human[0]);
        this.conversation.groups = Array.from(this.messageRecipients.filter(x => x.role === 'group'), x => x.id);
        let { error, data, status } = await create(this.conversationEntity, this.conversation);
        if (error) {
          this.selectedData = true;
          console.log('error', error);
        } else {
          this.loading = false;
          this.message.conversation = data.id;
          this.message.sender = this.Agency.human[0];
          this.saveMessage();
        }
      }
    },
    async saveMessage () {
      let { error, data, status } = await create(this.entity, this.message);
      if (error) {
        this.selectedData = true;
        console.log('error', error);
      } else {
        // this.Message.push(data);
        // let messageData = [];
        // messageData.message = data.id;
        // this.Conversation[this.conversationIndex].message.push(messageData);
        swal.fire({
          type: 'success',
          title: 'Message sent successfully',
          showConfirmButton: false,
          timer: 2500,
          onClose: () => {
            this.$router.push({ path: '/admin/messages' });
          }
        });
        this.updateConversationList();
      }
    },     
    backToListing () {
      window.getApp.$emit('pageSubHeader', '');
      this.$router.push({ path: '/admin/messages' });
    }     
  }
};
</script>

<style lang="css" scoped>
  .editor-button-container{
    padding-top: 70px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Messages/admin_add.vue